module.exports = __webpack_public_path__ + "static/img/tongyong_ar_01.5a9c81b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tongyong_ar_01.png
// module id = rQ7u
// module chunks = 0